<template>
  <div>
    <div class="banner" :style="bannerStyle">
      <div class="banner-head" >{{banner.head}}</div>
      <div class="banner-box" >
        <div class="banner-wrapper">
          <hr class="banner-line">
          <div class="banner-en" >{{banner.headEn}}</div>
          <hr class="banner-line">
        </div>
      </div>
      <div class="banner-subhead">{{banner.subhead}}</div>
    </div>
    <nav class="content-nav">
      <ul>
        <li v-for="(item,index ) in dataList" >
          <a :href="'#'+item.sequence">{{item.head}}</a>
        </li>
      </ul>
    </nav>
    <div class="content-line" :id="item.sequence" v-for="(item,index ) in dataList">
      <div class="content-item">
        <div class="item left">
          <span class="sequence"  >{{item.sequence}}</span>
          <span class="head">{{item.head}}</span>
          <p class="subhead">{{item.subhead}}</p>
          <div class="feature">技术特点</div>
          <p class="description" v-html="item.description"></p>
        </div>
        <img class="item right" :src="common.getPictureUrl(item)"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "KeyTech",
    methods: {
      loadData() {
        this.common.post('content/list',
          { 'type':'tech',},(response)=>{
            this.dataList = response.data.content;
            }
          )
        this.common.post('content/recentOne', {
            'type':'banner',
            'description':'tech',
          },(response)=>{
            this.banner = response.data.content;
            this.bannerStyle = {
              'background-image': 'url('+this.$host+this.banner.image+')'
            };
          }
        )
      },
    },
    updated(){
      let position = window.location.href.substr(window.location.href.indexOf("#")+1)
      // console.log("document.getElementById(position) :"+document.getElementById(position) );
      // console.log("position :"+position );
      if(document.getElementById(position)){
        document.getElementById(position).scrollIntoView(true);
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.loadData();
      })
    },
    data() {
      return {
        dataList:[],
        common:this.$common,
        bannerStyle:{},
        banner:{},
      }
    }
  }
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/Tech.vue